<template>
  <div :id="uuid" :style="{width:width+'px',height:height+'px'}"/>
</template>

<script setup>
import {getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty } from "@/utils/refresh-cpt-data";
import {onBeforeUnmount, onMounted, watch, computed} from "vue";
import * as echarts from 'echarts'

const props = defineProps({
  width:Number,
  height:Number,
  option:Object,
  show:Boolean,
  components:Array,
  current: Object
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(() => props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
watch(() => props.option.attribute, (obj) => {
    processData(props.option.cptDataForm,newData,jsFunFlag)
  loadChart(obj);
},{deep:true})
watch(() => [props.width,props.height], () => {
  chart.resize()
})

let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let dataStr = {}
let labelData = []
let valData = []
let timer = null
let scrollIndex = 0
let newData = "";
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

onMounted(()=>{
  chart = echarts.init(document.getElementById(uuid))
  if (dataReload.value.includes(0)) {
    refreshCptData();
  }
})

function refreshCptData(cptDataForm = props.option.cptDataForm,paras) {
  if (timer){
    clearInterval(timer);
  }
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm,paras),
  props.components)
}
function loadData(cptDataForm,paras) {
  getDataJson(cptDataForm,paras,(res)=> {
        // dataStr = res;
          newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
          jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
          processData(cptDataForm,newData,jsFunFlag)
        loadChart(props.option.attribute);

      })
}
function processData(cptDataForm,res,jsFunFlag){
          // 第一层判断 如果选择数据集
          if(cptDataForm.dataSource == '4') {
            // 第二层判断 ，如果没有配转换脚本
            if(jsFunFlag) { // 没有全部配置映射字段
                if(hasNonEmptyValues(props.option.attribute.cptTableData)) {
                    const dataKey = props.option.attribute.cptTableData;
                     let newarr = [];
                      // 遍历原始数组并重组数据
                        res.forEach(item => {
                          let name = item[dataKey[0].value];
                          let value = item[dataKey[1].value];

                          // 创建新的对象并添加到 aa 数组中
                          newarr.push({ name, value });
                        });
                        console.log(newarr,'新数组')
                        dataStr = newarr; 
              }
             } else { // 如果配置了转换脚本
                dataStr = res;
             }
          } else { // 不是数据集类型，是静态数据
               dataStr = res;
          } 
  }
function sort(attribute){
  labelData = [];
  valData = [];
  let data = JSON.parse(JSON.stringify(dataStr))
  if (attribute.sort === 'desc'){
    data.sort((a, b) => {
      return a.value - b.value
    })
  } else if(attribute.sort === 'asc'){
    data.sort((a, b) => {
      return b.value - a.value
    })
  }
  data.forEach(item => {
    labelData.push(item.name)
    valData.push(item.value)
  })
}
function scroll(attribute){
  if (timer){
    clearInterval(timer);
    timer = null;
  }
  if(attribute.enableScroll){
    if(attribute.showLine >= valData.length){//显示行 >= 最大行
      clearInterval(timer);
      timer = null;
      chart.setOption(chartOption);
      return;
    }
    chartOption.series[0].data = valData.slice(0, attribute.showLine).reverse();
    chartOption.yAxis.data = labelData.slice(0, attribute.showLine).reverse();

    scrollIndex = 0;
    timer = setInterval( ()=> {
      ++scrollIndex;//下一帧
      let start;
      let end;
      if(attribute.scrollType === 'one'){//单列滚动
        start = scrollIndex;
        end = start + attribute.showLine;
        if(scrollIndex === valData.length - attribute.showLine+1){
          start = 0;
          end = attribute.showLine;
          scrollIndex = 0;
        }
      }else{//整列滚动
        start = attribute.showLine * scrollIndex;
        end = start + attribute.showLine;
        if(start >= valData.length){
          start = 0;
          end = attribute.showLine;
          scrollIndex = 0;
        }
      }
      chartOption.series[0].data = valData.slice(start, end).reverse()
      chartOption.yAxis.data = labelData.slice(start, end).reverse()
      chart.setOption(chartOption);
    }, attribute.scrollTime * 1000)
  }else {
    timer = null
  }
  chart.setOption(chartOption);
  chart.on('click', (params) => {
    emit("clickHandler",props.option.interaction,'default',params.name)
  })
}
function loadChart(attribute) {
  sort(attribute)
  const color = new echarts.graphic.LinearGradient(
      0, 0, 1, 0,
      [
        {offset: 0, color: attribute.barColor[0]},
        {offset: 1, color: attribute.barColor[1]}
      ]
  )
  chartOption = {
    color: color,
    title: {
      text:attribute.chartTitle,
      textStyle:{
        color: attribute.titleTextColor,
        fontSize: attribute.titleSize
      },
      left:attribute.titleLeft,
      top:attribute.titleTop
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      ...attribute.tooltip,
    },
    grid: {
      x:attribute.gridX,y:attribute.gridY,x2:attribute.gridX2,y2:attribute.gridY2,
      containLabel: true
    },
    xAxis: {
      show: attribute.xAxisShow,
      type: 'value',
      axisLabel:{color: attribute.xLabelColor},
      axisLine:{
        show: attribute.xLineShow,
        lineStyle:{color: attribute.xLineColor}
      },
      axisTick:{show: false},
      splitLine: {show: attribute.xGridLineShow}
    },
    yAxis: {
      type: 'category',
      data: labelData,
      axisLabel:{
        color: attribute.yLabelColor,
        fontSize: attribute.yLabelSize
      },
      axisLine:{show: false},
      axisTick:{show: false},
      splitLine: {show: attribute.yGridLineShow}
    },
    series: [
      {
        data: valData,
        type: 'bar',
        showBackground: attribute.barBgShow,
        backgroundStyle: {
          color: 'rgba(180, 180, 180, 0.2)'
        },
        barWidth: attribute.barWidth,
        itemStyle: {borderRadius: attribute.barBorderRadius},
        label: {
          show: attribute.barLabelShow, //数值
          position: attribute.barLabelPosition,
          color: attribute.barLabelColor,
          fontSize: attribute.barLabelSize,
          formatter: '{c}'+attribute.barLabelUnit
        }
      },
      /*{//光点
        show: false,
        data: valData,
        name: 'tt',
        type: 'pictorialBar',
        symbol: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAhCAYAAAC4JqlRAAAFb0lEQVRYhY1YW28bRRT+ZtbrS24mjVu3btPUDoiqFIEQ4gUh8dKX8hf4A/wT+Am88cA7b5GgrxVPFIREL0rapHHbOHGcxM7Fa3u9c9BMZrZn1+umI43W2j2Xb75z5pwZi89/JLznEExMTFGhKb+njtyUD+KCZxaILOfTnvGIAfj3z5/hmjGcnpjyLosBPtPvtB+yfsxIMBCuQWY4komnD09eRVHMoISc1R9jTH0EahcDhIisM5V6mhmugfz75t35qlgOyJTTxJQ3MCcqqIo8yhRBIcQQCmOrmYOPgvAgaYQedbCnXuPUgkhPYsBiBjjNzrGnp1hEUd7CCiTmqIsjtYsmnRllyfSMQTELKa5iQVTxsXcZp6qJJh0gAAwrbjgQWpc4gLTznKxjUSyhgR660Qu8hDLv8w5cCkBEZ4joBU4h0fNWsSjr+IQWsKm2cDQlYQ2AdJKdO2+gIi5hhV6jpXYRAijpHLIzlwXAZAMQ6gBFGziWVxGIG2hIgW21iQ6TFe7JGYhjLmuY187VS7SoYwxr5wU78xaEZ+VhaY2Mc2AEYKi/q10MxRgtHUI5wFDtoGd14qTMpTNeFOHLGupqD23qmBVp58XUzFsWOICxdT5g4AR1EFAJbW2TDvGYBnFSCs5AzIJcRZVGGKtX6AOYsasu2d8lxoafAhDalfPwmOTUtsQi5rXt6DFe8zqSTEIfnphBNdrAG+sgb1fuAMzaZ7FxG40rNaxo5fYOtjefYZOtXrCtZkKjmuh4H+E6fLQQGrbEBACvjjKFGFHXCMxaAJyB2cvXcOPre/h+dgE33SpW7wCffoXmnw/w637LrJBYWExeUBdn2rb2Ea1j3wGQiV0wgzKdmAKSs9PnIOY/QOXb7/ADd+7G3AJu6m9ahoUpz3ZNztieQZn7lJwB4WOGjg2NcS1gIPJffoN7+SIW087d0N+0jJNPbVmpbQvfMCs4A2+TUKKAU0PZREXUhipV3J3m3A0rk2N6MmZa25YGWJyEMqUvSLGkTE0/j4WLAPgFI5Opz2zHIw2AbFDSbfW8k4U4uQhAODIymfrMdiYAgsIIcyZuxDpY5MrsYRtPLwJw2MYzm/1OT8UNSNtWplglWnC8YhqjL+bNvlestrsKN3r0EA/sCqeu/tFD/OHkmb4Bom1rH/yAIhkaQh89MY+5RGN5W9sH3QPsPfwdPwd9tNPOg/75Ny1jC9LQ6oYOhLHdN/0g0Q1jBlQTPe8u6qIMSb2J2m4q3M42Nn/7BT/d/gx3KtXzetDZQ/PZv3hCyvT+vp2B1TVMaJsij0K0HgMwIBIAKMCYBmjLZVSinqlWI9Z0XHmNSGH09B/8BeBvq897QcAAxCzIZVzWtrWPLAAOhFIbaMm7qMgaimrHKPNEdeV1eEE3HHAGtC1RRDH6D+vsRAQHgG8VRQOMqY0tUcOHIsAbOjJG0rX9XeeBIZ9iEULUUFVtPNe2kTqkJkLgDOlckHm8kqtYVlvYoQMDImKrfPeJyNIuluDJOmrUxSttk23LRAjcEckdErSQUM/Rlg0or45bqowDtWkMhLy2pw+lfOvKBsryEpbUIV7a45irC/GJOM2AYB+MoFakE/TlMla8L1CmQxypFk4MuZNVVOn+J6+Z45xuWMNoG09o3yTkGMnjOTJ3AYvn252xj9NoH09lHQtiCVdyVdwifScYYYjIynqmxRSEjwKNcUxdbKkXhjGVqoYqlXMTu4BnO88LqbZwiC10RQmeuI5ZUUAJecvCGIqOEag3OKMgEefM21F6F5hh72xkr2eJozPLD1AAQc9NELIup9x4VkOCu5ZN3A3dC+6MGZt2W06Pd92G3QITY9r1PEHTe/43wHWzfk8OAP8D28XBfaJJ48oAAAAASUVORK5CYII=',
        symbolPosition: 'end',
        symbolSize: [22, 22],
        symbolOffset: [10, 0],
        z: 20,
      }*/
    ]
  };
  scroll(attribute);
}

onBeforeUnmount(() => {
  if(timer){
    clearInterval(timer);
    timer = null;
  }
})

defineExpose({refreshCptData})
</script>

<style scoped>

</style>
